import React from "react";
import ProgressLoader from "../../ProgressLoader.js";
import { Playbtn2Hoc, VideoIcon3Hoc } from "../../../../../../assets/images";
import { captionLink, getThumbBase64URL, millisToMinutesAndSeconds } from "../../../../../../Helpers/Utility";
import Translate from "./Translate";

const VideoComponent = (props = {}) => {
  const {
    thumbURL,
    handleMediaShow,
    isSender = true,
    uploadStatus = 0,
    messageObject = {},
    imgFileDownloadOnclick,
    imageHeightAdjust = false,
    pageType
  } = props;

  const {
    msgId = "",
    msgBody: {
      translatedMessage = "",
      media: { caption = "", file_url = "", duration, thumb_image = "", webWidth, webHeight } = {}
    } = {}
  } = messageObject;

  const [dimension, setDimension] = React.useState({
    width: `${webWidth}px`,
    height: `${imageHeightAdjust ? "auto" : webHeight + "px"}`,
    maxHeight: webHeight + "px"
  });
  const [thumbImgSrc] = React.useState(thumbURL || getThumbBase64URL(thumb_image));

  React.useEffect(() => {
    if (thumbURL) {
      setDimension({
        width: `${webWidth}px`,
        height: `${imageHeightAdjust ? "auto" : webHeight + "px"}`,
        maxHeight: webHeight + "px"
      });
    }
  }, [thumbURL, msgId]);

  const isTranslated = () =>
    isSender && pageType === "conversation" && translatedMessage && Object.keys(translatedMessage).length;

  return (
    <>
      <div className="image-wrapper">
        <div className={`image-message`} onClick={(e) => handleMediaShow && handleMediaShow(e)} style={dimension}>
          <img className="webchat-conver-image" src={thumbImgSrc} alt="chat-img" />

          <div className="image-overlay">
            <span className="duration">
              <i>
                <VideoIcon3Hoc viewBox="0 0 12.014 7.059" />
              </i>
              <span className="video-duration">{millisToMinutesAndSeconds(duration)}</span>
            </span>
            <i className="playbtn">
              <Playbtn2Hoc viewBox ="0 0 35 35" />
            </i>
          </div>
        </div>
        <ProgressLoader
          msgId={msgId}
          isSender={isSender}
          file_url={file_url}
          uploadStatus={uploadStatus}
          imgFileDownloadOnclick={imgFileDownloadOnclick}
        />
      </div>
      <div className="image-caption">
        {caption !== "" && (
          <span>
            <span>{captionLink(caption)}</span>
            {!!isTranslated() && <Translate tMessage={translatedMessage} />}
          </span>
        )}
      </div>
    </>
  );
};

export default VideoComponent;
